import { useQuery } from '@tanstack/react-query';
import { LookupRecord } from '../api/masterData';
import { useApplicationFormApi } from '../pages/students/wizard/applicationFormApi';

/** Universities a dropdown may offer: the active ones, plus — so an
 * existing record still shows what it has saved — a university that is
 * already selected on the record but has since been deactivated (e.g. a
 * test entry such as "Debug Univ" taken out of use), labelled "(inactive)".
 * An inactive university is never offered as a new choice. */
export const selectableUniversities = (
  all: LookupRecord[] | undefined,
  selectedIds: Array<number | '' | null | undefined>,
): LookupRecord[] | undefined =>
  all
    ?.filter((u) => u.isActive !== false || selectedIds.includes(u.id as number))
    .map((u) => (u.isActive === false ? { ...u, name: `${String(u.name)} (inactive)` } : u));

export const useUniversityOptions = (
  selectedIds: Array<number | '' | null | undefined>,
  params: Record<string, unknown> = {},
  enabled = true,
) => {
  // The application form's data source: the staff API everywhere except
  // the Student Portal's Application Form.
  const { listLookup, mode } = useApplicationFormApi();
  const query = useQuery({
    queryKey: ['lookup', '/master-data/universities', 'with-inactive', mode, params],
    queryFn: () => listLookup('/master-data/universities', params),
    enabled,
  });
  return { ...query, data: selectableUniversities(query.data, selectedIds) };
};
